import React, { useMemo } from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { useEventContext } from '../../../../context/EventContext';
import getFullname from '../../../../helpers/get-fullname';
import getMemberNickname from '../../../../helpers/get-member-nickname';
import MemberPhoto from '../MemberPhoto';
import './style.scss';

const VISIBLE_MEMBER_COUNT = 4;

/**
 * 
 * @param {array} members  Members array
 * @param {string} membersType Members type title
 * @param {function} onMemberClick callback
 * @returns {ReactComponent}
 */
const MembersSimpleView = ({episode, hasPhotos = true, hasNames = true, isPdf = false, onMemberClick}) => {
    if (!episode.groups.length) {
        return null;
    }

    const $locale = useLocaleContext();
    const {event} = useEventContext();
    const {moduleEpisode} = event || {};

    if (!moduleEpisode?.membersEnabled) return null;

    const episodeGroups = useMemo(() => {
        return episode.groups.map((group) => ({
            ...group,
            members: group.members.filter(({member}) => !member.hide)
        })).slice(0, VISIBLE_MEMBER_COUNT);;
    }, [episode]);

    return (
        episodeGroups.map((group) =>(
            !!group.members?.length &&
            <div
                key={group.id}
                className="members-simple"
            >
            {
                (hasPhotos && episode.hiddenMembersPhotosInUnexpanded === false) &&
                    <div className="members-simple__photos">
                        {
                            group.members?.map(({member}, index) => (
                                <div
                                    key={index}
                                    className={`members-simple__photos-item`}
                                    style={{
                                        marginLeft: `-${index ? 10 : 0}px`,
                                        zIndex: 5 - index
                                    }}
                                >
                                    <MemberPhoto
                                        key={index}
                                        photo={member?.previewUrl}
                                        size="sm"
                                        initials={getMemberNickname(member, $locale)}
                                        isPdf={isPdf}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onMemberClick(member);
                                        }}
                                    />
                                </div>
                            ))
                        }
                        {
                            group.members?.length > VISIBLE_MEMBER_COUNT &&
                            <div
                                className="members-simple__photos-more"
                                style={{
                                    marginLeft: `-10px`,
                                }}
                            >
                                +{group.members?.length - VISIBLE_MEMBER_COUNT}
                            </div>
                        }
                    </div>
                }
                {
                    hasNames && !!group.members.length &&
                    <div className="members-simple__names">
                        <p className="members-simple__names-role">
                            {$locale.getProperty(group.role, group.members?.length > 1 ? 'groupTitle' : 'title')}:
                        </p>
                        <p className="members-simple__names-fullname">
                            {group.members?.map(({member}) => getFullname(member, $locale)).join(', ')}
                        </p>
                    </div>
                }
            </div>
        ))
    )
};

export default MembersSimpleView;
